import { render } from "./dialog_normal.vue?vue&type=template&id=f066a934&scoped=true"
import script from "./dialog_normal.vue?vue&type=script&lang=js"
export * from "./dialog_normal.vue?vue&type=script&lang=js"

import "./dialog_normal.vue?vue&type=style&index=0&id=f066a934&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f066a934"]])

export default __exports__